import { Flex, Box } from '@blockanalitica/ui';
import { Outlet, Link } from 'react-router';
import { ReactNode } from 'react';
import { styled } from 'styled-components';
import {
  default as Logo
  // @ts-ignore
} from '@/assets/logos/compound.svg?react';
import Footer from './Footer';

const Wrapper = styled(Flex)`
  box-sizing: border-box;
`;

const ContentWrapper = styled(Flex)`
  box-sizing: border-box;
  padding: ${(props) =>
    `${props.theme.space['xs']} ${props.theme.space['s-m']} ${props.theme.space['s-m']}`};
`;

type LayoutProps = {
  children?: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  return (
    <Wrapper height="100%" flexWrap="nowrap" width="100%" gap="0">
      <ContentWrapper
        flexGrow={1}
        flexShrink={1}
        flexBasis={['100%', 'auto']}
        margin={'0 auto'}
        width="100%"
        maxWidth={['100vw', '80rem']}
        flexDirection="column"
        justifyContent="space-between"
        gap="s">
        <Box
          // @ts-ignore
          as={Link}
          to="/">
          <Logo height={27} />
        </Box>

        <main>{children ? children : <Outlet />}</main>

        <Footer />
      </ContentWrapper>
    </Wrapper>
  );
}
